// generated by genversion
export var version = '4.0.3';
//# sourceMappingURL=version.js.map